import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_EncounterEvent = {
    _v1: {
        createEvents: { method: HttpMethod.POST, path: '/v1/create-events' },
    },
};
//# sourceMappingURL=api-def.js.map